import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";

export const HighContrastToggle = () => {
  const [isHighContrast, setIsHighContrast] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("high-contrast");
    if (saved === "true") {
      setIsHighContrast(true);
      document.documentElement.classList.add("high-contrast");
    }
  }, []);

  const toggleHighContrast = () => {
    setIsHighContrast((prev) => {
      const next = !prev;
      if (next) {
        document.documentElement.classList.add("high-contrast");
        localStorage.setItem("high-contrast", "true");
      } else {
        document.documentElement.classList.remove("high-contrast");
        localStorage.setItem("high-contrast", "false");
      }
      return next;
    });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleHighContrast}
      aria-label={isHighContrast ? "Disable high contrast mode" : "Enable high contrast mode"}
      className={`rounded-full h-9 w-9 p-0 flex items-center justify-center ${isHighContrast ? "bg-primary text-primary-foreground hover:bg-primary/90" : "text-muted-foreground hover:text-primary"}`}
    >
      {isHighContrast ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      <span className="sr-only">High Contrast</span>
    </Button>
  );
};
